/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TomoQuestionnaire } from '../../models/tomo-questionnaire';

export interface PostTomoquestionnaire$Plain$Params {
  'api-version'?: string;
  
    /**
     * questionnaire to create
     */
    body?: TomoQuestionnaire
}

export function postTomoquestionnaire$Plain(http: HttpClient, rootUrl: string, params?: PostTomoquestionnaire$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TomoQuestionnaire>> {
  const rb = new RequestBuilder(rootUrl, postTomoquestionnaire$Plain.PATH, 'post');
  if (params) {
    rb.query('api-version', params['api-version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TomoQuestionnaire>;
    })
  );
}

postTomoquestionnaire$Plain.PATH = '/tomoQuestionnaire';
